"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _dataCapsule = require("data-capsule");
var _utils = require("./utils/utils");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var WorkerStrategy = exports["default"] = /*#__PURE__*/function (_BaseStorage) {
  function WorkerStrategy() {
    var _this;
    _this = _BaseStorage.call(this) || this;
    _this.workerWindow = _utils.utils.getWorkerWindow();
    return _this;
  }
  _inheritsLoose(WorkerStrategy, _BaseStorage);
  var _proto = WorkerStrategy.prototype;
  _proto.setItem = function setItem(key, value) {
    return this.getCartService().then(function (service) {
      service.setItem(key, value);
    });
  };
  _proto.getItem = function getItem(key) {
    return this.getCartService().then(function (service) {
      var value = service.getItem(key);
      return Promise.resolve(value);
    });
  };
  _proto.removeItem = function removeItem(key) {
    return this.getCartService().then(function (service) {
      service.removeItem(key);
    });
  };
  _proto.getAllItems = function getAllItems() {
    return this.getCartService().then(function (service) {
      var result = service.getAllItems();
      return Promise.resolve(result);
    });
  };
  _proto.getCartService = function getCartService() {
    var _this2 = this;
    if (this.cartService) {
      return Promise.resolve(this.cartService);
    }
    if (this.workerWindow.cartService) {
      this.cartService = this.workerWindow.cartService;
      return Promise.resolve(this.cartService);
    }
    return new Promise(function (resolve, reject) {
      var counter = 0;
      var interval = setInterval(function () {
        _this2.workerWindow = _utils.utils.getWorkerWindow();
        if (_this2.workerWindow.cartService) {
          _this2.cartService = _this2.workerWindow.cartService;
          clearTimeout(interval);
          resolve(_this2.cartService);
        }
        counter++;
        if (counter > 60) {
          clearTimeout(interval);
          reject('Cannot get cart service from worker');
        }
      }, 1000);
    });
  };
  return WorkerStrategy;
}(_dataCapsule.BaseStorage);